


























































































































































































import { Component, Vue } from 'vue-property-decorator';
import { IProfileFields } from '@/common/types';

import Welcome from '@/components/Global/Welcome.vue';
import Loading from '@/components/Global/Loading.vue';
import Sidebar from '@/components/Global/Sidebar/Sidebar.vue';
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';
import Alert from '@/components/Global/Alert.vue';
import RadioField from '@/components/Form/RadioField.vue';
import Validation from '@/components/Form/Validation.vue';

// Services
import Brand from '@/services/Brand';
import User from '@/services/User';
import Misc from '@/services/Misc';
import { captureException as SentryCaptureException } from '@sentry/browser';

// Validations
import { required, email, requiredIf, sameAs, minLength } from 'vuelidate/lib/validators';
import { helpers } from 'vuelidate/lib/validators';

const pwdReq = helpers.regex(
	'pwdReq',
	/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,}$/,
);

@Component({
	name: 'PageMyProfile',
	components: {
		Sidebar,
		TextField,
		Welcome,
		Alert,
		RadioField,
		Validation,
		Loading,
		SelectField,
	},
	validations: {
		profile: {
			first_name: {
				required,
			},
			last_name: {
				required,
			},
			multifactor: {
				required,
			},
			email: {
				requiredIf: requiredIf(vm => {
					return vm.multifactor === 'email';
				}),
				email,
			},
			cell_phone: {
				requiredIf: requiredIf(vm => {
					return vm.multifactor === 'sms';
				}),
			},
		},
		currentPassword: {
			minLength: minLength(10),
			pwdReq,
		},
		newPassword: {
			requiredIf: requiredIf(vm => {
				return vm.currentPassword !== '';
			}),
			minLength: minLength(10),
			pwdReq,
		},
		confirmPassword: {
			requiredIf: requiredIf(vm => {
				return vm.currentPassword !== '';
			}),
			sameAsPassword: sameAs('newPassword'),
		},
	},
})
export default class MyProfile extends Vue {
	private loading: boolean;
	private success: boolean;
	private error: boolean;
	private errorLoading: boolean;
	private states: any;
	private isInvalid: boolean;
	private profile: IProfileFields;
	private currentPassword: string;
	private newPassword: string;
	private confirmPassword: string;
	private errorPassword: boolean;
	private successPassword: boolean;
	private Brand: any;

	constructor() {
		super();

		this.loading = true;
		this.isInvalid = false;
		this.error = false;
		this.errorLoading = false;
		this.success = false;
		this.states = Misc.stateList();
		this.profile = {
			first_name: '',
			last_name: '',
			cell_phone: '',
			email: '',
			address_line_1: '',
			address_line_2: '',
			city: '',
			state: '',
			postal_code: '',
			multifactor: 'sms',
		};

		this.currentPassword = '';
		this.newPassword = '';
		this.confirmPassword = '';
		this.errorPassword = false;
		this.successPassword = false;
		this.Brand = Brand;
	}

	get details() {
		return Brand.getBrandInformation();
	}

	private async saveProfile() {
		this.isInvalid = false;
		this.success = false;
		this.error = false;

		this.$v.$touch();
		if (this.$v.$invalid) {
			this.isInvalid = true;
			window.scrollTo(0, 0);
			return;
		}

		if (
			this.currentPassword.length > 0 ||
			this.newPassword.length > 0 ||
			this.confirmPassword.length > 0
		) {
			this.changePassword();
			return;
		}

		this.error = false;
		this.success = false;
		try {
			const saveUserProfile = await User.saveUserProfile(this.profile);
			this.success = true;
		} catch (e) {
			SentryCaptureException(e);
			this.error = true;
		}
	}

	private changeState($event) {
		this.profile.state = $event.target.value;
	}

	private async changePassword() {
		this.$Amplify.Auth.currentAuthenticatedUser()
			.then(user => {
				return this.$Amplify.Auth.changePassword(
					user,
					this.currentPassword,
					this.newPassword,
				);
			})
			.then(data => {
				this.successPassword = true;
				window.changePassword = true;
				this.$store.dispatch('Auth/signout');
			})
			.catch(err => {
				this.errorPassword = true;
				return;
			});
	}

	private async created() {
		try {
			const getUserProfile = await User.getUserProfile();

			this.profile = Object.assign(this.profile, getUserProfile.data.profile);
			if (!this.profile.hasOwnProperty('multifactor')) {
				this.profile.multifactor = 'sms';
			}
		} catch (e) {
			this.errorLoading = true;
			SentryCaptureException(e);
		} finally {
			this.loading = false;
		}
	}
}
